<script setup>
definePage({
  meta: {
    layout: 'default',
    action: 'view',
    subject: 'Reminder',
  },
})

const page = {
  groupTitle: 'Kepegawaian (HR)',
  icon: 'ri-notification-3-line',
  color: 'info',
  title: 'Reminder & Pengingat',
  description: 'Rekap seluruh pengingat jatuh tempo — STR/SIP, kalibrasi alat, dan lainnya.',
  purpose: 'Panduan membaca halaman rekap pengingat lintas jenis, supaya tidak ada tanggal penting yang terlewat.',
  concept: [
    {
      icon: 'ri-timer-line',
      title: 'Satu Halaman, Banyak Sumber',
      text: 'Pengingat STR/SIP pegawai dan kalibrasi alat kesehatan sama-sama muncul di sini, dikelompokkan berdasarkan status: Jatuh Tempo, Akan Datang, atau Semua.',
    },
    {
      icon: 'ri-refresh-line',
      title: 'Berhenti Otomatis Setelah Diperbarui',
      text: 'Reminder untuk sebuah objek (mis. STR seorang pegawai) otomatis berhenti begitu tanggal berlakunya diperbarui di halaman aslinya (Kredensial Pegawai/Kalibrasi Alat) — Anda tidak perlu mematikan reminder secara manual.',
    },
  ],
  steps: [
    { title: 'Buka menu Kepegawaian → Reminder & Pengingat', detail: 'Default menampilkan yang sudah "Jatuh Tempo".' },
    { title: 'Ganti tab ke "Akan Datang" atau "Semua" sesuai kebutuhan', detail: 'Bandingkan untuk merencanakan tindakan lebih awal.' },
    { title: 'Klik satu baris untuk menuju halaman aslinya', detail: 'Mis. klik reminder STR untuk langsung ke halaman Kredensial Pegawai orang tersebut.' },
  ],
  tips: [
    'Cek halaman ini secara rutin (mis. tiap Senin pagi) sebagai bagian rutinitas mingguan Tim Mutu/HR.',
  ],
  faq: [
    { q: 'Kenapa reminder yang sudah lewat tanggal tetap muncul?', a: 'Disengaja — reminder yang sudah lewat jatuh tempo TETAP ditampilkan sampai objeknya benar-benar diperbarui, supaya hal-hal yang sudah kedaluwarsa tidak diam-diam hilang dari perhatian.' },
  ],
  related: [
    { title: 'Kredensial Pegawai', sub: 'Sumber reminder STR/SIP', icon: 'ri-award-line', color: 'info', to: { name: 'help-kepegawaian-kredensial-pegawai' } },
    { title: 'Kalibrasi Alat Kesehatan', sub: 'Sumber reminder kalibrasi', icon: 'ri-tools-line', color: 'secondary', to: { name: 'help-fasilitas-kalibrasi-alat' } },
  ],
}
</script>

<template>
  <GuidePageLayout v-bind="page" />
</template>
